import api from '../Axios';

export interface IDashaBirthDetailsPayload {
  dateOfBirth: string; // Format: dd/mm/yyyy
  timeOfBirth: string; // Format: HH:MM
  latitude: string | number;
  longitude: string | number;
  timezone?: number;   // Defaults to 5.5 if omitted
}

export interface IDashaReportResponse {
  success: boolean;
  order_of_dashas: string[];
  mahadasha: any;
  antardasha: any;
  paryantardasha: any;
  Shookshamadasha: any;
  Pranadasha: any;
}

export const astrologyAPI = {
  // ---------------------------------------------------------
  // EXISTING FUNCTIONALITY FOR LIVE CHAT (UNTOUCHED)
  // ---------------------------------------------------------
  generateKundliChart: async (sessionId: string, chartStyle: 'north' | 'south' | 'east' = 'north') => {
    const response = await api.post('/api/astrology/generate-chart', { 
      sessionId, 
      style: chartStyle 
    });
    return response.data; 
  },

  // ---------------------------------------------------------
  // NEW FUNCTIONALITY FOR EXPERT DASHBOARD KUNDLI TOOL
  // ---------------------------------------------------------
  generateManualKundli: async (data: {
    dateOfBirth: string;
    timeOfBirth: string;
    latitude: string;
    longitude: string;
    style: string;
  }) => {
    // We map the frontend fields to the exact variable names expected by your backend Controller
    const response = await api.post('/api/experts/astrology/generate-manual', {
      date: data.dateOfBirth,
      time: data.timeOfBirth,
      lat: parseFloat(data.latitude),
      lon: parseFloat(data.longitude),
      style: data.style
    });
    
    return response.data;
  },

  // ---------------------------------------------------------
  // NEW FUNCTIONALITY FOR DASHA REPORTS (SEPARATE PIPELINES)
  // ---------------------------------------------------------
  /**
   * Independent Dasha API Pipeline (POST Method)
   * Directly sends birth detail coordinates without requiring a database session ID.
   */
  fetchIndependentDasha: async (data: IDashaBirthDetailsPayload): Promise<IDashaReportResponse> => {
    const response = await api.post('/api/astrology/dasha', {
      date: data.dateOfBirth,
      time: data.timeOfBirth,
      latitude: typeof data.latitude === 'string' ? parseFloat(data.latitude) : data.latitude,
      longitude: typeof data.longitude === 'string' ? parseFloat(data.longitude) : data.longitude,
      tz: data.timezone ?? 5.5
    });
    return response.data;
  },

  /**
   * Session-based Dasha API Pipeline (GET Method)
   * Resolves birth details dynamically from the database session intake mapping.
   */
  fetchSessionDasha: async (sessionId: string): Promise<IDashaReportResponse> => {
    const response = await api.get(`/api/astrology/dasha/${sessionId}`);
    return response.data;
  }
};